import { Dialog, Button, DialogTitle, DialogContentText, DialogActions, DialogContent } from '@mui/material';
import { toTitleCase } from '../../../utils';
import { useContent } from '../../../logic'

interface CompleteTaskDialogProps {
    open: boolean;
    setUserCompleteOpen: (open: boolean) => void;
    onUserCompleteTask: () => void;
}

export function CompleteTaskDialog({ open, setUserCompleteOpen, onUserCompleteTask }: CompleteTaskDialogProps) {

  const { TaskText, TasksText } = useContent()

  return <Dialog key="userComplete" open={open}>
    <DialogTitle>Complete {toTitleCase(TaskText)}</DialogTitle>

    <DialogContent>
      <DialogContentText sx={{ mb: 1 }}>Are you sure you want to mark this {TaskText} as completed?</DialogContentText>
      <DialogContentText>If needed, completed {TasksText} can be restarted.</DialogContentText>
    </DialogContent>

    <DialogActions>
      <Button variant="rounded" onClick={() => setUserCompleteOpen(false)}>
                Not yet
      </Button>
      <Button variant="contained" onClick={onUserCompleteTask}>
                Yes, complete it
      </Button>
    </DialogActions>
  </Dialog>
}